import { combineReducers } from 'redux'

// Reducers
/* eslint-disable */
import configuration from './api_v2/configuration'

// Export Actions
export * as configuration from './api_v2/configuration'
/* eslint-enable */

export default combineReducers({
  configuration
})
